export const NAME_FIELD_KEY = 'name';
export const COPY_FROM_ID_FIELD_KEY = 'copyFromId';
